import styled from 'styled-components/macro';
import { fonts, mediaQuery } from '@noths/styles-config';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  font-family: ${fonts.family.v3};
  flex-direction: column;
  ${mediaQuery('tablet desktop')} {
    margin-top: 16px;
    margin-bottom: 32px;
  }
`;

export const ForgotPasswordContainer = styled.div({
  width: '100%',
  textAlign: 'right',
  padding: '10px 0',
});

export const ButtonContainer = styled.div({
  width: '100%',
  marginTop: '20px',
  alignSelf: 'flex-end',
});
